
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftLeft25 as ObiThreewayAnalogInleftLeft25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-left-25.js';
 
 
 

 
 export const ObiThreewayAnalogInleftLeft25 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-left-25',
   elementClass: ObiThreewayAnalogInleftLeft25Element,
   events: {
     
   }
  });
 
 